import React from "react";

interface StyledChipProps {
    onClose: () => void;
    text: string;
    isDisabled?: boolean
}


export const StyledChip = ({ text, onClose }: StyledChipProps) => {
    return (
        <div className={"styled-chip"}>
            {text}
            <i className={"icon icon-close"} onClick={onClose} ></i>
        </div>
    );
};